import { ChangeDetectorRef, Component, Input, OnChanges } from '@angular/core';
import { GermanCalculatorSummaryData } from '../../types/german-calculator.type';

@Component({
  selector: 'ft-gc-result-summary-data',
  templateUrl: './gc-result-summary-data.component.html',
  styleUrls: ['./gc-result-summary-data.component.scss'],
})
export class GcResultSummaryDataComponent implements OnChanges {
  @Input() summaryData: GermanCalculatorSummaryData[];

  constructor(private cdr: ChangeDetectorRef) {}

  ngOnChanges(): void {
    this.cdr.detectChanges();
  }
}
